import Typography from '@mui/material/Typography';
import ConfirmationDialog from 'components/system/ConfirmationDialog';

const TeamMemberRemovalConfirmation = ({
  onClose, onConfirm, onCancel, memberName,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <ConfirmationDialog
      title="Remove Team Member"
      onClose={onClose}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmText="Remove"
      reversed
    >
      <Typography variant="body2">
        Are you sure you want to remove
        {' '}
        {memberName}
        {' '}
        from the team?
      </Typography>
    </ConfirmationDialog>
  );
};

export default TeamMemberRemovalConfirmation;
